import React from "react"

import { CreateMarketplaceLoanResponse } from "@lib/clients/nelo-api-client"

import NeloBackgroundContainer from "./nelo-background-container"

interface PaymentScheduleDisplayProps {
  loanDetails: CreateMarketplaceLoanResponse | null
}

const LoanDetailsDisplay: React.FC<PaymentScheduleDisplayProps> = ({ loanDetails }) => {
  if (!loanDetails || !loanDetails.loanInfo || !loanDetails.loanInfo.schedule) {
    return null
  }

  const { schedule } = loanDetails.loanInfo

  return (
    <NeloBackgroundContainer title="Calendario de pagos">
      <div className="mt-4 rounded-xl bg-white p-4 shadow-md">
        <div className="space-y-4">
          {schedule.map((item, index) => (
            <div key={index} className="flex items-center">
              <div className="relative">
                <div className="flex h-6 w-6 items-center justify-center rounded-full border-2 border-nelo-blue bg-white">
                  <div className="h-3 w-3 rounded-full bg-nelo-blue"></div>
                </div>
                {index < schedule.length - 1 && (
                  <div className="absolute left-1/2 top-6 h-[calc(100%+1rem)] w-0.5 -translate-x-1/2 bg-nelo-blue"></div>
                )}
              </div>
              <div className="ml-4 grow">
                <p className="font-nunito text-sm text-ui-fg-base">{item.labelTitle}</p>
                <p className="font-nunito font-medium">{item.label}</p>
              </div>
              <div className="text-right">
                <p className="font-nunito text-sm text-ui-fg-base">{item.valueTitle}</p>
                <p className="font-nunito font-medium">{item.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </NeloBackgroundContainer>
  )
}

export default LoanDetailsDisplay
